module.exports = __webpack_public_path__ + "static/media/404error.e5e6085f.svg";